import AsyncStorage from "@react-native-async-storage/async-storage"
import { Platform } from "react-native";
import DeviceInfo from "react-native-device-info";
import { clientConfigPath } from "../../config/Constant";


export const sendAnalytics = (category, actionType, extraLabel = {}, callback) => {
    return async (dispatch, getState) => {
        console.log("sending analytics...");


        const deviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');
        const sessionToken = await AsyncStorage.getItem("sessionToken");
        const currentDuration = await AsyncStorage.getItem("currentDuration");

        if (process.env.REACT_APP_SEND_ANALYTICS == 'false' || !sessionToken || !category || !actionType) {
            console.log("Cannot send GA event: ", { sessionToken, category, actionType, extraLabel });
            return;
        }


        const { appVersion, appBuildNumber, isLoggedIn, loggedInRoomNumber } = getState().appConfigSlice;
        const { currentGuestDetails } = getState().guestDetailsSlice;

        const reservationNumber = await AsyncStorage.getItem("sessionReservationNumber") || currentGuestDetails?.reservationNumber;
        const confirmationNumber = await AsyncStorage.getItem("sessionConfirmationNumber");


        const InfoLabel = {
            ...extraLabel,
            sourceApp: "guestJourneyApp",
            appVersion: `${appVersion}(${appBuildNumber})`,
            Room: loggedInRoomNumber,
            bookingNumber: reservationNumber || confirmationNumber,
            guestToken: currentGuestDetails?.guestToken,
            locationId: currentGuestDetails?.location,
            layoutId: currentDuration,
            deviceIdentifierFromCMS: deviceIdentifier,
            platform: Platform.OS,
            timeStamp: new Date().toISOString(),
        };

        console.log("proceeding with sending analytics...");

        try {
            const response = await clientConfigPath.post("/deviceAnalytics/send", {
                header: {
                    dataSource: "guestJourney",
                    sessionToken
                },
                payload: {
                    data: [{
                        category: category.trim().replace(/[\s-]/g, "_"),
                        action: actionType,
                        label: InfoLabel,
                        value: 0,
                        appendDemographics: false
                    }]
                }
            });

            console.log("Analytics sent successfully");
            callback?.(true);
        } catch (error) {
            console.log("Error sending analytics", error);
            callback?.(false);
        }
    };
};
